import { render, staticRenderFns } from "./PasswordEmail.vue?vue&type=template&id=51ffac0a&scoped=true"
import script from "./PasswordEmail.vue?vue&type=script&lang=js"
export * from "./PasswordEmail.vue?vue&type=script&lang=js"
import style0 from "./PasswordEmail.vue?vue&type=style&index=0&id=51ffac0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ffac0a",
  null
  
)

export default component.exports